import styled from 'styled-components';
import FreeCancellationIconSvg from '../../assets/hotels/amenities/freeCancellation.svg';

const FreeCancellationIcon = styled(
  FreeCancellationIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default FreeCancellationIcon;
